import { render, staticRenderFns } from "./ReportTypePicker.vue?vue&type=template&id=31dda198"
import script from "./ReportTypePicker.vue?vue&type=script&lang=js"
export * from "./ReportTypePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports